import styles from './index.module.scss'
import logo from 'static/images/Logo.png'
import { useHistory } from 'react-router-dom'
import { useEffect, useState, useMemo, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { UnorderedListOutlined, CloseOutlined } from '@ant-design/icons'
import {
  Drawer,
  MenuList,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

// 自定义样式配置，处理Popper/Paper自适应宽度与指定背景色
const usePopperStyles = makeStyles({
  // Popper内部Paper容器样式：自适应宽度 + 背景色#663751
  popperPaper: {
    width: 'auto !important',
    minWidth: 'unset !important',
    whiteSpace: 'nowrap',
    boxSizing: 'content-box',
    // 核心修改：设置弹出框背景色为#663751
    backgroundColor: '#663751 !important',
    // 可选：设置文字颜色为白色，提升深色背景下的可读性
    color: '#ffffff',
  },
  // 菜单项样式，保持内容展示正常
  menuItem: {
    whiteSpace: 'nowrap',
    paddingLeft: '16px',
    paddingRight: '16px',
    // 可选：菜单项hover状态背景色，适配主背景
    '&:hover': {
      backgroundColor: '#7a4a62 !important',
    },
  },
  drawerPaper: {
    backgroundColor: '#b43a5e',
  },
})

const WHHeader = () => {
  const [scrollDeviation, setScrollDeviation] = useState(0)
  const history = useHistory()
  const popperClasses = usePopperStyles()

  const isConnect = useMemo(() => {
    return history?.location?.pathname == '/contact'
  }, [history?.location?.pathname])
  const isAbout = useMemo(() => {
    return history?.location?.pathname == '/about'
  }, [history?.location?.pathname])
  const isProducts = useMemo(() => {
    return history?.location?.pathname == '/products'
  }, [history?.location?.pathname])

  const { t, i18n } = useTranslation()
  const handleScroll = () => {
    setScrollDeviation(document.documentElement.scrollTop || document.body.scrollTop)
  }

  const jumpHome = () => {
    history.push('/home')
  }

  const jumpProduct = () => {
    history.push('/products')
  }

  const websites = {
    zh: {
      mock: 'https://hskmock.cn/',
      course: 'https://app.wohuimandarin.cn/',
      go: 'https://hskgo.com/',
      studyInChina: 'https://www.studyinchina.com/',
    },
    en: {
      mock: 'https://hskmock.com/',
      course: 'https://app.wohuimandarin.com/',
      go: 'https://hskgo.com/',
      studyInChina: 'https://www.studyinchina.com/',
    },
  }

  const jumpMock = () => {
    const url = process.env.REACT_APP_ENVIRONMENT === 'en' ? websites.en.mock : websites.zh.mock
    window.open(url)
  }
  const jumpGo = () => {
    const url = process.env.REACT_APP_ENVIRONMENT === 'en' ? websites.en.go : websites.zh.go
    window.open(url)
  }

  const jumpCourses = () => {
    const url = process.env.REACT_APP_ENVIRONMENT === 'en' ? websites.en.course : websites.zh.course
    window.open(url)
  }
  const jumpStudyInChina = () => {
    const url =
      process.env.REACT_APP_ENVIRONMENT === 'en'
        ? websites.en.studyInChina
        : websites.zh.studyInChina
    window.open(url)
  }
  const jumpForSchool = () => {
    history.push('/products')
  }

  const saveLangToLocal = (lang) => {
    localStorage.setItem('wohui:lang', lang)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const bgblack = useMemo(() => {
    const isHome = history?.location?.pathname == '/home'
    return (scrollDeviation > 70 && isHome) || !isHome
  }, [scrollDeviation, history?.location?.pathname])

  const aboutUs = () => {
    history.push('/about')
  }
  const connectUs = () => {
    history.push('/contact')
  }

  const products = () => {
    history.push('/products')
  }
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const MobileDrawer = () => {
    const classes = usePopperStyles()
    const [drawerVisible, setDrawerVisible] = useState(false)
    return (
      <>
        {drawerVisible ? (
          <CloseOutlined className='icon-style' onClick={() => setDrawerVisible(false)} />
        ) : (
          <UnorderedListOutlined
            className='icon-style'
            onClick={() => setDrawerVisible(!drawerVisible)}
          />
        )}

        <Drawer
          className='mobile-drawer'
          anchor={'right'}
          open={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          classes={{ paper: classes.drawerPaper }}
        >
          <div
            className='tab-list'
            onClick={() => {
              setDrawerVisible(false)
            }}
          >
            <div
              className={`tab-item no-border ${isProducts ? 'route-active' : ''}`}
              onClick={() => {
                setTimeout(() => {
                  products()
                }, 500)
              }}
            >
              {t('header.products')}
            </div>
            <div>
              <MenuList classes={{ root: 'mobile-sub-menu' }}>
                <MenuItem onClick={jumpCourses}>{t('header.hsk-course')}</MenuItem>
                <MenuItem onClick={jumpMock}>{t('header.hsk-mock')}</MenuItem>
                <MenuItem onClick={jumpGo}>{t('header.hsk-go')}</MenuItem>
                <MenuItem onClick={jumpStudyInChina}>{t('header.hsk-study-in-china')}</MenuItem>
                <MenuItem onClick={jumpForSchool}>{t('header.for-school')}</MenuItem>
              </MenuList>
            </div>
            <div
              className={`tab-item ${isAbout ? 'active' : ''}`}
              onClick={() => {
                setTimeout(() => {
                  aboutUs()
                }, 500)
              }}
            >
              {t('header.about_us')}
            </div>
            <div
              className={`tab-item ${isConnect ? 'active' : ''}`}
              onClick={() => {
                setTimeout(() => {
                  connectUs()
                }, 500)
              }}
            >
              {t('header.connect')}
            </div>
            <div
              className='tab-item language'
              onClick={() => {
                setTimeout(() => {
                  i18n.changeLanguage(i18n.language == 'en' ? 'zh' : 'en')
                  saveLangToLocal(i18n.language)
                }, 500)
              }}
            >
              {i18n.language == 'en' ? '中文' : 'EN'}
            </div>
          </div>
        </Drawer>
      </>
    )
  }

  const ProductPopover = () => {
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const doOpen = useCallback(
      (e) => {
        e.stopPropagation()
        if (!anchorRef.current) return
        setOpen((prevOpen) => !prevOpen)
        if (anchorRef.current.children[0]) {
          anchorRef.current.children[0].className = `tab active ${isProducts ? 'route-active' : ''}`
        }
      },
      [isProducts]
    )

    const doClose = useCallback(
      (event) => {
        if (!anchorRef.current) {
          setOpen(false)
          return
        }
        if (anchorRef.current.contains(event.target)) {
          return
        }
        setOpen(false)
        if (anchorRef.current.children[0]) {
          anchorRef.current.children[0].className = `tab ${isProducts ? 'route-active' : ''}`
        }
      },
      [isProducts]
    )

    const handleMouseLeave = useCallback(
      (event) => {
        if (!anchorRef.current || !event.relatedTarget || !(event.relatedTarget instanceof Node)) {
          setOpen(false)
          if (anchorRef.current && anchorRef.current.children[0]) {
            anchorRef.current.children[0].className = `tab ${isProducts ? 'route-active' : ''}`
          }
          return
        }

        if (
          !anchorRef.current.contains(event.relatedTarget) &&
          !event.relatedTarget.closest('.popper-content')
        ) {
          setOpen(false)
          if (anchorRef.current.children[0]) {
            anchorRef.current.children[0].className = `tab ${isProducts ? 'route-active' : ''}`
          }
        }
      },
      [isProducts]
    )

    const handleListKeyDown = useCallback((event) => {
      if (event.key === 'Tab') {
        event.preventDefault()
        setOpen(false)
        if (anchorRef.current && anchorRef.current.children[0]) {
          anchorRef.current.children[0].className = 'tab'
        }
      }
    }, [])

    useEffect(() => {
      return () => {
        setOpen(false)
      }
    }, [])

    const prevOpen = useRef(open)
    useEffect(() => {
      if (prevOpen.current === true && open === false && anchorRef.current) {
        anchorRef.current.focus()
      }
      prevOpen.current = open
    }, [open])

    const popperModifiers = useMemo(
      () => [
        {
          name: 'flip',
          enabled: true,
        },
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            rootBoundary: 'viewport',
            altAxis: true,
            padding: 8,
          },
        },
        {
          name: 'hide',
          enabled: false,
        },
      ],
      []
    )

    return (
      <>
        <div
          ref={anchorRef}
          className='m-r-28 sub-tab'
          onMouseEnter={doOpen}
          onMouseLeave={handleMouseLeave}
          onClick={jumpProduct}
        >
          <div className={`tab ${isProducts ? 'active' : ''}`}>{t('header.products')}</div>
        </div>

        {open && anchorRef.current && (
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement='bottom-start'
            role={undefined}
            transition
            className='popper-content'
            modifiers={popperModifiers}
            disablePortal={false}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                {/* 应用自定义样式，包含背景色#663751 */}
                <Paper classes={{ root: popperClasses.popperPaper }}>
                  <ClickAwayListener onClickAway={doClose}>
                    <MenuList
                      autoFocusItem={false}
                      id='menu-list-grow'
                      onKeyDown={handleListKeyDown}
                      onMouseLeave={doClose}
                    >
                      <MenuItem className={popperClasses.menuItem} onClick={jumpCourses}>
                        {t('header.hsk-course')}
                      </MenuItem>
                      <MenuItem className={popperClasses.menuItem} onClick={jumpMock}>
                        {t('header.hsk-mock')}
                      </MenuItem>
                      <MenuItem className={popperClasses.menuItem} onClick={jumpGo}>
                        {t('header.hsk-go')}
                      </MenuItem>
                      <MenuItem className={popperClasses.menuItem} onClick={jumpStudyInChina}>
                        {t('header.hsk-study-in-china')}
                      </MenuItem>
                      <MenuItem className={popperClasses.menuItem} onClick={jumpForSchool}>
                        {t('header.for-school')}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        )}
      </>
    )
  }

  const LanguageSelector = () => {
    return (
      <>
        <div
          className='language tab'
          onClick={() => {
            i18n.changeLanguage(i18n.language == 'en' ? 'zh' : 'en')
            saveLangToLocal(i18n.language)
          }}
        >
          {i18n.language == 'en' ? '中文' : 'ENGLISH'}
        </div>
      </>
    )
  }

  return (
    <div className={styles.styles}>
      <div className='header-main'>
        <img src={logo} alt='logo' onClick={jumpHome} />
        {isMobile ? (
          <MobileDrawer></MobileDrawer>
        ) : (
          <div className='tools'>
            <ProductPopover />
            <div className={`m-r-28 tab ${isAbout ? 'active' : ''}`} onClick={aboutUs}>
              {t('header.about_us')}
            </div>
            <div className={`m-r-28 tab ${isConnect ? 'active' : ''}`} onClick={connectUs}>
              {t('header.connect')}
            </div>
            <LanguageSelector />
          </div>
        )}
      </div>
    </div>
  )
}

export default WHHeader
